<ps-ui-multi-country-traditional-view
  *ngIf="multiCountrySurveyData.length"
  [surveyDetails]="surveyDetails"
  [surveyPayload]="surveyPayload"
  [multiCountrySurveyData]="multiCountrySurveyData"
  (updateMultiCountrySurveyData)="updateMultiCountrySurveyData.emit($event)"
  [isCpiEditable]="isCpiEditable"
  [allCountries]="countries"
  [filteredCountries]="filteredCountries"
  [selectedTemplateId]="selectedTemplateId"
  (selectionChange)="selectionChange.emit($event)"
  (mcSurveyAdded)="mcSurveyAdded.emit($event)"
  (cancelTemplateSelection)="cancelTemplateSelection.emit($event)"
></ps-ui-multi-country-traditional-view>

<ps-ui-multi-country-single-project-view
  *ngIf="multiCountrySpvChildSurveys.length"
  [multiCountrySpvParentSurvey]="multiCountrySpvParentSurvey"
  [multiCountrySpvChildSurveys]="multiCountrySpvChildSurveys"
  [mcSvpPayload]="mcSvpPayload"
  [currentlySelectedSpvSurvey]="surveyDetails"
  [isCpiEditable]="isCpiEditable"
  [filteredCountries]="filteredCountries"
  (updateMcSpvChildSurveysData)="updateMcSpvChildSurveysData.emit($event)"
  (mcSurveyAdded)="mcSurveyAdded.emit($event)"
>
</ps-ui-multi-country-single-project-view>
